import { createFileRoute } from '@tanstack/react-router'
import Breadcrumb from '@/components/Breadcrumb'
import en from '@/i18n/locales/en.json'

export const Route = createFileRoute('/$locale/dmca')({ component: DMCA })

function DMCA() {
  const pp = (en.footer && (en.footer.dmca as any)) || {}
  const title = pp.title || 'DMCA Notice'
  const effectiveDate = pp.effectiveDate || 'Effective date: 2026-09-08'
  const body = pp.body || ''
  const sections = (pp && pp.sections) || {}
  const copy = pp.copyright || '© ByteOne (UK) LTD. All rights reserved.'
  const sectionKeys = sections ? Object.keys(sections) : []

  return (
    <>
      <Breadcrumb text1="Home" text2={title} />
      <main className="main-content" style={{ paddingTop: '8px' }}>
        <div className="container-fluid collections-container">
          <div className="col-12 py-0">
            <div className="pixel-card mt-2" style={{ padding: '24px 16px', borderRadius: '12px' }}>
              <h1 className="h4 text-white mb-3">{title}</h1>
              <p className="text-secondary small mb-2">{effectiveDate}</p>
              <p className="text-secondary small">{body}</p>
              {sectionKeys.map((key) => {
                const s = (sections as any)[key]
                return (
                  <div key={key} className="mt-3">
                    <h5 className="text-white mb-2">{s.heading}</h5>
                    <p className="text-secondary small">{s.body}</p>
                  </div>
                )
              })}
              <p className="text-secondary small mt-4 mb-0">{copy}</p>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}